import { Modal } from './Modal/index'
import { PopoverClick } from './Popover/PopoverClick/index'
import { PopoverHover } from './Popover/PopoverHover/index'

export const Popups = {
  Modal,
  PopoverClick,
  PopoverHover,
}
